import { dropTipoParada } from 'utils/drops';

const getTipoParadaFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'tipo',
    label: 'Tipo',
    type: 'select',
    options: dropTipoParada,
    multiple: true,
    initial: true,
  },
  { name: 'descricao', label: 'Descrição' },
];

export default getTipoParadaFilterFields;
